export var handleError = function (controllerParams) {
    return function (e) {
        console.error(e);
        controllerParams.controllerConfig.setProps({ generalError: true });
        controllerParams.appData.reportError(e);
    };
};
//# sourceMappingURL=handleError.js.map